var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7154 0.0896102C17.8923 0.198934 18 0.392054 18 0.600001V18.6C18 18.9314 17.7314 19.2 17.4 19.2H13.8C13.4686 19.2 13.2 18.9314 13.2 18.6V16.8H12V18.6C12 18.9314 11.7314 19.2 11.4 19.2H0.6C0.268629 19.2 0 18.9314 0 18.6V12C0 11.7417 0.165258 11.5125 0.410263 11.4308L7.2 9.16755V5.4C7.2 5.17274 7.3284 4.96498 7.53167 4.86334L17.1317 0.0633443C17.3177 -0.0296522 17.5385 -0.0197138 17.7154 0.0896102ZM7.2 10.4325L1.2 12.4325V18H7.2V10.4325ZM8.4 18H10.8V16.2C10.8 15.8686 11.0686 15.6 11.4 15.6H13.8C14.1314 15.6 14.4 15.8686 14.4 16.2V18H16.8V1.57082L8.4 5.77082V18Z",
    fill: "#128B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 13.2H3.6V14.4H2.4V13.2Z",
    fill: "#128B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 13.2H6V14.4H4.8V13.2Z",
    fill: "#128B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 15.6H3.6V16.8H2.4V15.6Z",
    fill: "#128B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 15.6H6V16.8H4.8V15.6Z",
    fill: "#128B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 10.8H10.8V12H9.6V10.8Z",
    fill: "#128B9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.8H13.2V12H12V10.8Z",
    fill: "#128B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 13.2H10.8V14.4H9.6V13.2Z",
    fill: "#128B9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2H13.2V14.4H12V13.2Z",
    fill: "#128B9B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 10.8H15.6V12H14.4V10.8Z",
    fill: "#128B9B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 13.2H15.6V14.4H14.4V13.2Z",
    fill: "#128B9B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 8.4H10.8V9.6H9.6V8.4Z",
    fill: "#128B9B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.4H13.2V9.6H12V8.4Z",
    fill: "#128B9B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 8.4H15.6V9.6H14.4V8.4Z",
    fill: "#128B9B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 6H10.8V7.2H9.6V6Z",
    fill: "#128B9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H13.2V7.2H12V6Z",
    fill: "#128B9B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6H15.6V7.2H14.4V6Z",
    fill: "#128B9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 3.6H15.6V4.8H14.4V3.6Z",
    fill: "#128B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsIcon);
export default __webpack_public_path__ + "static/media/buildings-icon.2b4704d0a6b1c985c9a5dc967d2c5043.svg";
export { ForwardRef as ReactComponent };